import { createFileRoute, redirect } from "@tanstack/react-router";

// Search params validation for Auth0 error handling
const searchSchema = {
  error: undefined as string | undefined,
  error_description: undefined as string | undefined,
};

export const Route = createFileRoute("/")({
  validateSearch: (search: Record<string, unknown>) => ({
    error: search.error as string | undefined,
    error_description: search.error_description as string | undefined,
  }),
  beforeLoad: ({ search }) => {
    // If there's an Auth0 error in the URL, pass it to the error page
    if (search.error) {
      throw redirect({
        to: "/auth-error",
        search: {
          error: search.error,
          error_description: search.error_description,
        },
        replace: true,
      });
    }

    // Redirect directly to /app, which will handle authentication
    // This removes the landing page step, taking users straight to login if needed
    throw redirect({
      to: "/app",
      replace: true,
    });
  },
  component: () => null,
});
